import { MARKET_TRADES_SIZE, ORDER_LIMIT } from "../../constants/constants";
import { ACTION_TYPE, AddOrderEvent, IGetDepth, IGetLastTrades, IMarketTrade, IPair, IPairDto, ITransaction, ITransfer, LastTradeEvent, OperationStatusEnum, PairSettingsIds, UpdateOrderEvent, UserTradeEvent } from "../../interfaces";
import { amountValueFormate, equalsIgnoreCase, findCorrectAsset, isTxnDone, sortByDate } from "../../_utils/comman";
import { buildPair, getActualElement, joinPairToOrder, mapToCodexBalance } from "../../_utils/mappers";
import { AccountAssetType, CodexBalance, CodexBalanceDto, IOrderDto, ITradeDto, Order, OrderExecutionType, OrderFilterType, OrderStatus, OrderTypeEnum, OrderUpdateStaus } from "../../_utils/types";
import BigNumber from "bignumber.js";
import { saveSelectedPair } from "./user.action";
import { marketsBalancesApi, marketsOrdersApi, walletApi } from "@ultrade/react-sdk";
import { OrderExecution } from "@ultrade/ultrade-js-sdk";

/** seting action types */
export const actionTypes = {
  // ============== For User Data ==============
  SAVE_USER_ORDERS : "SAVE_USER_ORDERS",
  SAVE_DEPOSIT_BALANCE: "SAVE_DEPOSIT_BALANCE",
  SAVE_USER_WALLET_TRANSACTIONS: "SAVE_USER_WALLET_TRANSACTIONS",
  SAVE_PENDING_TRANSACTIONS_COUNT: "SAVE_PENDING_TRANSACTIONS_COUNT",
  SAVE_USER_EXCHANGE_ASSETS: "SAVE_USER_EXCHANGE_ASSETS",
  SAVE_DOLLAR_PRICES: "SAVE_DOLLAR_PRICES",

  // ================ Order Book ============================
  UPDATE_ORDER_BOOK: "UPDATE_ORDER_BOOK",
  BUY_ORDERS_TOTAL_COUNT: "BUY_ORDERS_TOTAL_COUNT",
  SELL_ORDERS_TOTAL_COUNT: "SELL_ORDERS_TOTAL_COUNT",
  SAVE_FLASH_ORDERS: "SAVE_FLASH_ORDERS",
  SAVE_LTP: "SAVE_LTP",

  // ================ User Orders ============================
  SAVE_ORDER_PRICE: "SAVE_ORDER_PRICE",
  SAVE_ORDER_AMOUNT: "SAVE_ORDER_AMOUNT",
  SAVE_ORDER_TOTAL: "SAVE_ORDER_TOTAL",
  SAVE_BUY_SELL_TAB: "SAVE_BUY_SELL_TAB",
  SAVE_LIMIT_MARKET_TAB: "SAVE_LIMIT_MARKET_TAB",
  SAVE_OPEN_HISTORY_TAB: "SAVE_OPEN_HISTORY_TAB",

  // ================ Market Trades ============================
  SAVE_MARKET_TRADES: "SAVE_MARKET_TRADES",

  // ================ Market Pairs ============================
  SAVE_LIST_OF_PAIRS: "SAVE_LIST_OF_PAIRS",
  SAVE_MFT: "SAVE_MFT",

  // ================ Reset on pair Change ============================
  SAVE_INITIAL_STATE: "SAVE_INITIAL_STATE",

  // ================ Reset on Account Change ============================
  SAVE_INITIAL_WALLET_STATE: "SAVE_INITIAL_WALLET_STATE",

  //================= Charts =================
  SAVE_CHART_TRADE: "SAVE_CHART_TRADE",
};

/**
 * Save array of assets or update balances of one asset
 */
// export const saveExchangeAssets = (data: AccountAssetType[] | CodexBalanceDto) => (dispatch, getState) => {
//   if (Array.isArray(data)) {
//     const newAssets: AccountAssetType[] = data;
//     dispatch({ type: actionTypes.SAVE_USER_EXCHANGE_ASSETS, data: newAssets });
//   } else {
//     const assets: AccountAssetType[] = getState().exchange.exchangeAssets;
//     const balance: CodexBalance = mapToCodexBalance(data);
//     const updatedAssets = assets.map((a) => {
//       return !findCorrectAsset(a.index, balance.tokenId, a.chainId, balance.tokenChainId)
//         ? a
//         : {
//           ...a,
//           amount: balance.availableAmount,
//           lockedAmount: balance.lockedAmount,
//         }
//     });
//     dispatch({ type: actionTypes.SAVE_USER_EXCHANGE_ASSETS, data: updatedAssets });
//   }
// };

export const saveDollarPrices = (data: { [key: string]: number }) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_DOLLAR_PRICES, data: data });
};

/**
 * Save open or history orders tab
 */
export const saveUserOrdersType = (data: OrderExecutionType) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_OPEN_HISTORY_TAB, data: data });
};

/**
 * Save Buy or Sell side tab
 */
export const saveBuySellTab = (data: "B" | "S") => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_BUY_SELL_TAB, data: data });
};

/**
 * Save limit market tab
 */
export const saveLimitMarketTab = (data: "M" | "L") => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_LIMIT_MARKET_TAB, data: data });
};

/**
 * Save user order input price
 */
export const saveOrderPrice = (data: string) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_ORDER_PRICE, data: data });
};

/**
 * Save user order input amount
 */
export const saveOrderAmount = (data: string) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_ORDER_AMOUNT, data: data });
};

/**
 * Save user order input total
 */
export const saveOrderTotal = (data: string) => (dispatch) => {
  dispatch({ type: actionTypes.SAVE_ORDER_TOTAL, data: data });
};

/**
 * Save user order input total
 */
// export const updateOrderBook = (data: IGetDepth) => (dispatch, getState) => {
//   if (getState().user.selectedPair?.pair_key !== data.pair) {
//     return;
//   }
//   if (getState().exchange.lastUpdateId >= data.u) {
//     return;
//   }
//   const calculateOrder = (array: Array<string[]>) => array.map(arr => {
//     return [
//       arr[0],
//       arr[1],
//       amountValueFormate(BigNumber(arr[0]).multipliedBy(arr[1]).toString(), getState().user.selectedPair?.base_decimal)
//     ]
//   });

//   dispatch({
//     type: actionTypes.UPDATE_ORDER_BOOK,
//     data: {
//       lastUpdateId: data.u,
//       buy: calculateOrder(data.buy),
//       sell: calculateOrder(data.sell)
//     }
//   });
// };


/**
 * Save Orderbook total buy orders save from DB count
 */
export const saveBuyOrdersTotalCount = (data: number) => (dispatch) => {
  dispatch({ type: actionTypes.BUY_ORDERS_TOTAL_COUNT, data: data });
};

/**
 *  Save Orderbook total sell orders save from DB count
 */
export const saveSellOrdersTotalCount = (data: number) => (dispatch) => {
  dispatch({ type: actionTypes.SELL_ORDERS_TOTAL_COUNT, data: data });
};

/**
 * Save Flash orders for flashing only
 */
export const saveFlashOrders = (type: "add" | "sub", newOrder) => (dispatch, getState) => {
  const flashOrders = getState().exchange.flashOrders?.slice();
  if (type === "add") {
    flashOrders.push(newOrder);
  } else {
    flashOrders.shift();
  }
  dispatch({ type: actionTypes.SAVE_FLASH_ORDERS, data: flashOrders });
};

/**
 * Save User Orders (open and hstory) Information
 */
// export const saveUserOrders = (orders: IOrderDto[], ordersType: OrderExecutionType) => (dispatch, getState) => {
//   const allPairs = getState().exchange.listOfPairs;
//   const stateOrders = marketsOrdersApi.endpoints.getOrders.select({status: null})(getState() as any).data
//   const newOrders = joinPairToOrder(orders, allPairs);

//   const filteredOrders = getActualElement(stateOrders[ordersType], newOrders, (a: Order, b: Order) => a.pairId === b.pairId && a.id === b.id);

//   if (equalsIgnoreCase(ordersType, OrderExecutionType.open)) {
//     filteredOrders.sort((a,b) => sortByDate(a.createdAt, b.createdAt));
//   } else {
//     filteredOrders.sort((a,b) => sortByDate(a.completedAt, b.completedAt));
//   }

//   dispatch({ type: actionTypes.SAVE_USER_ORDERS, data: { ...stateOrders, [ordersType]: filteredOrders }});
// };

// export const saveAllUserOrders = (openOrders: IOrderDto[], historyOrders: IOrderDto[]) => (dispatch, getState) => {
//   const allPairs = getState().exchange.listOfPairs;
//   const openFullOrders = joinPairToOrder(openOrders, allPairs);
//   const historyFullOrders = joinPairToOrder(historyOrders, allPairs);

//   dispatch({ type: actionTypes.SAVE_USER_ORDERS, data: { 
//     open: openFullOrders.sort((a,b) => sortByDate(a.createdAt, b.createdAt)), 
//     close: historyFullOrders.sort((a,b) => sortByDate(a.completedAt, b.completedAt))
//   }});
// };

// export const clearUserOrders = () => (dispatch) => {
//   dispatch({ 
//     type: actionTypes.SAVE_USER_ORDERS, 
//     data: { open: [], close: [] }
//   });
// }

/**
 * Save User Wallet Balance Information
 */
// export const saveDepositBalance = (data: CodexBalanceDto[]) => (dispatch, getState) => {
//   const selectedPair = getState().user.selectedPair;
//   const depositBalance = marketsBalancesApi.endpoints.getBalances.select()(getState() as any).data;
//   const balances = data.map(b => mapToCodexBalance(b));

//   const baseAsset = balances.find(b => findCorrectAsset(b.tokenId, selectedPair.base_id, b.tokenChainId, selectedPair.base_chain_id));
//   const priceAsset = balances.find(b => findCorrectAsset(b.tokenId, selectedPair.price_id, b.tokenChainId, selectedPair.price_chain_id));
//   const newBalance = {
//     ...depositBalance,
//     base_available_balance: baseAsset ? baseAsset.availableAmount : depositBalance.base_available_balance,
//     base_locked_balance: baseAsset ? baseAsset.lockedAmount : depositBalance.base_locked_balance,
//     price_available_balance: priceAsset ? priceAsset.availableAmount : depositBalance.price_available_balance,
//     price_locked_balance: priceAsset ? priceAsset.lockedAmount : depositBalance.price_locked_balance,
//   }
//   dispatch({ type: actionTypes.SAVE_DEPOSIT_BALANCE, data: newBalance });
// };

/**
 * Save user wallet transactions (deposit, withdrawal, transfer)
 */
export const saveUserWalletTransactions = (type: ACTION_TYPE, data: ITransaction[] | ITransfer[]) => (dispatch) => {
  const copiedData = structuredClone(data);
  equalsIgnoreCase(type, ACTION_TYPE.T)
    ? copiedData.sort((a, b) => b.transferId - a.transferId)
    : copiedData.sort((a, b) => b.primaryId - a.primaryId)
    
  dispatch({ 
    type: actionTypes.SAVE_USER_WALLET_TRANSACTIONS, 
    data: { key: type, value: copiedData }
  })
  ;
}

/**
 * Update user wallet transactions via socket
 */
// export const updateUserWalletTransactions = (newData: ITransaction) => (dispatch, getState) => {
//   const txnType = newData.action_type;
//   const walletTransactions = getState().exchange.userTransactions[txnType];
//   const existingTransactionIndex = walletTransactions.findIndex(transaction => transaction.primaryId === newData.primaryId);
//   dispatch(updatePendingTxnsCount(newData, walletTransactions[existingTransactionIndex]));

//   let updatedWalletTransactions;
//   if (existingTransactionIndex !== -1) {
//     const exsistItem = walletTransactions.find((oldItem: ITransaction) => oldItem.primaryId === newData.primaryId);
//     if (equalsIgnoreCase(exsistItem.status, OperationStatusEnum.Completed)) return;

//     updatedWalletTransactions = [...walletTransactions];
//     updatedWalletTransactions[existingTransactionIndex] = newData;
//   } else {
//     updatedWalletTransactions = [newData, ...walletTransactions];
//   }

//   dispatch({ 
//     type: actionTypes.SAVE_USER_WALLET_TRANSACTIONS, 
//     data: { key: txnType, value: updatedWalletTransactions.sort((a, b) => b.primaryId - a.primaryId) }
//   });
// }

// export const updateTransferTransactions = (newData: ITransfer) => (dispatch, getState) => {
//   const walletTransfers = walletApi.endpoints.getWalletTransactions.select() getState().exchange.userTransactions.transfer;
//   const existingIndex = walletTransfers.findIndex(transaction => transaction.transferId === newData.transferId);
//   dispatch(updatePendingTxnsCount(newData, walletTransfers[existingIndex]));

//   let updatedWalletTransfers;
//   if (existingIndex !== -1) {
//     const isTxnUpdated = new Date(walletTransfers[existingIndex].completedAt).getTime() >= new Date(newData.completedAt).getTime();
//     if (isTxnUpdated) return;

//     updatedWalletTransfers = [...walletTransfers];
//     updatedWalletTransfers[existingIndex] = {...updatedWalletTransfers[existingIndex], ...newData};
//   } else {
//     updatedWalletTransfers = [newData, ...walletTransfers];
//   }

//   dispatch({ 
//     type: actionTypes.SAVE_USER_WALLET_TRANSACTIONS, 
//     data: { key: ACTION_TYPE.T, value: updatedWalletTransfers.sort((a, b) => b.transferId - a.transferId) }
//   });
// }

/**
 * Save user wallet pending transactions count
 */
export const savePendingTxnsCount = (count: number) => (dispatch) => {
  dispatch({ 
    type: actionTypes.SAVE_PENDING_TRANSACTIONS_COUNT, 
    data: count 
  })
}

const updatePendingTxnsCount = (newTxn: ITransfer | ITransaction, oldTxn?: ITransfer | ITransaction) => (dispatch, getState) => {
  const pendingTxnsCount = getState().exchange.pendingTxnsCount;
  let changesInPendingCount = 0;

  if (!oldTxn && !isTxnDone(newTxn.status)) {
    changesInPendingCount = 1;
  } else if (oldTxn && !isTxnDone(oldTxn.status) && isTxnDone(newTxn.status)) {
    changesInPendingCount = -1;
  }

  dispatch({ 
    type: actionTypes.SAVE_PENDING_TRANSACTIONS_COUNT, 
    data: pendingTxnsCount + changesInPendingCount 
  })
}

/**
 * Save chart trade
 */
// export const saveChartTrade = (data: LastTradeEvent) => (dispatch) => {
//   const [_1, _2, _3, price, amount, _6, date] = data;
//   dispatch({ type: actionTypes.SAVE_CHART_TRADE, data: [ price, amount, date ] });
// }

/**
 * Save intial redux state according to the wallet changes or pair change
 */
export const saveInitialState = (data: "pair" | "wallet") => (dispatch) => {
  if (data === "pair") {
    dispatch({ type: actionTypes.SAVE_INITIAL_STATE });
  }
  if (data === "wallet") {
    dispatch({ type: actionTypes.SAVE_INITIAL_WALLET_STATE });
  }
};

/**
 * Save list or pairs, merge with api and socket data, and also update the data to change according to socket data
 */
export const saveListOfPairs = (data: IPairDto[], selectedPairId: number = null) => (dispatch, getState) => {
  const listOfPairs = getState().exchange.listOfPairs;
  const cacheMFT = getState().exchange.mftCached;
  const minFee = getState().settings.minFee;

  const isMFT = data.some(el => el.pairSettings[PairSettingsIds.MFT_AUDIO_LINK] || el.pairSettings[PairSettingsIds.MFT_TITLE]);
  if (cacheMFT !== isMFT) {
    dispatch({ 
      type: actionTypes.SAVE_MFT, 
      data: isMFT 
    })
  };

  const pairsData = data.map(el => {
    const buildEl = buildPair(el, { minFee });
    const oldPair = listOfPairs.find((p: IPair) => equalsIgnoreCase(p.pair_key, el.pair_key));
    
    if (!oldPair) return buildEl;
    
    // Always overwrite statistics fields with new data from WebSocket
    return {
      ...oldPair,
      ...buildEl,
      // Force overwrite these statistical fields
      change_24: buildEl.change_24 !== 0 ? buildEl.change_24 : oldPair.change_24,
      volume_24: buildEl.volume_24 !== "0" && buildEl.volume_24 ? buildEl.volume_24 : oldPair.volume_24,
      total_24: buildEl.total_24 !== "0" && buildEl.total_24 ? buildEl.total_24 : oldPair.total_24,
      h: buildEl.h !== "0" && buildEl.h ? buildEl.h : oldPair.h,
      l: buildEl.l !== "0" && buildEl.l ? buildEl.l : oldPair.l,
      l_p: buildEl.l_p ? buildEl.l_p : oldPair.l_p,
      current_price: buildEl.current_price !== "0" && buildEl.current_price ? buildEl.current_price : oldPair.current_price,
    };
  });

  pairsData.sort((a, b) => (a.pair_name > b.pair_name ? 1 : b.pair_name > a.pair_name ? -1 : 0));
  dispatch({ type: actionTypes.SAVE_LIST_OF_PAIRS, data: pairsData });

  const currentPair = pairsData.find(el => el.id === selectedPairId);
  if (!currentPair) {
    dispatch(saveSelectedPair(pairsData[0]));
  } else  {
    dispatch(saveSelectedPair(currentPair));
  }
};

/**
 * Get the market trades
 */
// export const saveLastTrades = (data: IGetLastTrades[]) => (dispatch) => {

//   const lastTrades: IMarketTrade[] = [...data]
//     .sort((a, b) => sortByDate(a.createdAt, b.createdAt))
//     .map(({ tradeId, price, amount, createdAt: date, isBuyerMaker }) => ({
//       tradeId,
//       price,
//       amount,
//       date,
//       isBuyerMaker,
//     }));

//   if (lastTrades?.length > 0) {
//     let currentLtp = lastTrades[0].price;
//     let lastLtp = lastTrades?.length > 1 ? lastTrades[1].price : "0";
//     dispatch({
//       type: actionTypes.SAVE_LTP,
//       data: {
//         currentLtp,
//         lastLtp,
//       },
//     });
//     dispatch({
//       type: actionTypes.SAVE_MARKET_TRADES,
//       data: lastTrades,
//     });
//   }
// } 

/**
 * Update the market trade with single trade socket
 */
// export const saveExchangeTradeOnTrades = (data: LastTradeEvent) => (dispatch, getState) => {
//   try {

//     let markTradData = getState().exchange?.marketTrades?.slice();

//     const [_1, _2, tradeId, price, amount, _6, date, isBuyerMaker] = data;
//     const lastTrade: IMarketTrade = {
//       tradeId,
//       price,
//       amount,
//       date,
//       isBuyerMaker,
//     }

//     let currentLtp = lastTrade.price;
//     let lastLtp = "0";

//     if (markTradData.length) {
//       lastLtp = markTradData[0].price;
//     } else {
//       lastLtp = lastTrade.price;
//     }

//     const tradeIndex = markTradData.findIndex((item: IMarketTrade) => item.date <= lastTrade.date);
//     if (tradeIndex !== -1) {
//       markTradData.splice(tradeIndex, 0, lastTrade);
//     } else {
//       markTradData.push(lastTrade);
//     }

//     if (markTradData.length > MARKET_TRADES_SIZE) {
//       markTradData.pop();
//     }
//     dispatch({
//       type: actionTypes.SAVE_LTP,
//       data: {
//         currentLtp: currentLtp,
//         lastLtp: lastLtp,
//       },
//     });

//     dispatch({
//       type: actionTypes.SAVE_MARKET_TRADES,
//       data: markTradData,
//     });
//   } catch (error) {
//     console.log("saveExchangeTradeOnTrades Error :", { error });
//   }
// };

// export const removeOpenOrderBg = (data: Order) => (dispatch, getState) => {
//   const state = getState() as any;
//   const selectedPair = state.user.selectedPair;
//   const orderFilter = state.persist.ordersFilter
//   const openHistoryTab = state.exchange.openHistoryTab as OrderExecutionType

//   const symbol = orderFilter === OrderFilterType.CurrentPair 
//   ? selectedPair?.pair_key
//   : null
 
//   if (!selectedPair) {
//     return;
//   }
  
//   const cacheKey = {
//       symbol,
//       status: OrderExecution[openHistoryTab],
//       limit: ORDER_LIMIT,
//     }

//     dispatch(marketsOrdersApi.util.updateQueryData("getOrders", cacheKey, (draft)=>{
  
//       if (!draft || !draft.open) {
//         return;
//       }
  
//       const openOrderIdx = draft.open.findIndex((op: Order) => op.id === data.id);
  
//       if (openOrderIdx === -1) {
//         return;
//       }
  
//       draft.open[openOrderIdx].updateStatus = null
//     }));
// }

// export const moveOrderToHistory = (data: Order) => (dispatch, getState) => {
//   const state = getState() as any;
//   const selectedPair = state.user.selectedPair;
//   const orderFilter = state.persist.ordersFilter
//   const openHistoryTab = state.exchange.openHistoryTab as OrderExecutionType

//   const symbol = orderFilter === OrderFilterType.CurrentPair 
//   ? selectedPair?.pair_key
//   : null
  
//   if (!selectedPair) {
//     return;
//   }
  
//   const cacheKey = {
//     symbol,
//     status: OrderExecution[openHistoryTab],
//     limit: ORDER_LIMIT,
//   }

//     dispatch(marketsOrdersApi.util.updateQueryData("getOrders", cacheKey, (draft)=>{
//       if (!draft || !draft.open || !draft.close) {
//         return;
//       }
//       const openOrderIdx = draft.open.findIndex((op: Order) => op.id === data.id);
  
//       if (openOrderIdx === -1) {
//         return;
//       }
  
//       const newOpen = draft.open.filter(o => o.id !== data.id);
//       const newClose = draft.close.find(o => o.id === data.id) ? draft.close : [{ ...data, updateStatus: null }, ...draft.close];
  
//       draft.open = newOpen;
//       draft.close = newClose;
//     }));
// }

// export const saveNewOpenOrder = (data: AddOrderEvent) => (dispatch, getState) => {
//   const [ pairId, _pairKey, userId, id, side, type, price, amount, total, createdAt ] = data;
//   const { listOfPairs, userOrders } = getState().exchange;

//   const pair: IPair = listOfPairs.find((p: IPair) => p.id === pairId);
//   if (!pair) return;

//   const newOrder: Order = {
//     executed: false,
//     updateStatus: OrderUpdateStaus.created,
//     base_currency: pair.base_currency?.toUpperCase(),
//     base_decimal: pair.base_decimal,
//     price_currency: pair.price_currency?.toUpperCase(),
//     price_decimal: pair.price_decimal,
//     min_size_increment: pair.min_size_increment,
//     min_price_increment: pair.min_price_increment,
//     price_id: Number(pair.price_id),
//     id,
//     amount,
//     price,
//     total,
//     type,
//     status: OrderStatus.Open,
//     side: side as 0 | 1,
//     avgPrice: '0',
//     filledAmount: '0',
//     filledTotal: '0',
//     pairId: pair.id,
//     pair: pair.pair_key,
//     userId: userId,
//     createdAt,
//     completedAt: null,
//     trades: [],
//   };

//   dispatch({
//     type: actionTypes.SAVE_USER_ORDERS,
//     data: { ...userOrders, open: [ newOrder, ...userOrders.open ]},
//   });
// };

// export const updateOrder = (data: UpdateOrderEvent) => (dispatch, getState) => {
//   const [ _pairId, _pairKey, _userId, id, status, executedPrice, filledAmount, filledTotal, _updatedAt, completedAt ] = data;
//   const orders = marketsOrdersApi.endpoints.getOrders.select({status: null})(getState() as any).data
//   const openHistoryTab = getState().exchange.openHistoryTab;
//   const openOrders = [...orders.open] as Order[];
//   const closedOrders = [...orders.close] as Order[];
//   const openOrderIdx = openOrders.findIndex((op: Order) => op.id === id);
//   const closeOrderIdx = closedOrders.findIndex((op: Order) => op.id === id);

//   if (openOrderIdx === -1 && closeOrderIdx === -1) {
//     return;
//   }

//   const updatedOrder: Partial<Order> = {
//     status,
//     filledAmount,
//     filledTotal,
//     avgPrice: executedPrice,
//     completedAt
//   };

//   if (openOrderIdx !== -1 && updatedOrder.status === OrderStatus.Open) {
//     const isRapidOrder = openOrders[openOrderIdx].type === OrderTypeEnum.IOC || openOrders[openOrderIdx].type === OrderTypeEnum.Market;

//     openOrders[openOrderIdx] = {
//       ...openOrders[openOrderIdx],
//       ...updatedOrder,
//       updateStatus: isRapidOrder ? null : OrderUpdateStaus.partially_filled,
//     };
//   } else if (openOrderIdx !== -1 && updatedOrder.status !== OrderStatus.Open) {
    
//     if (equalsIgnoreCase(openHistoryTab, OrderExecutionType.open)) {
//       openOrders[openOrderIdx] = {
//         ...openOrders[openOrderIdx],
//         ...updatedOrder,
//         executed: true,
//         updateStatus: OrderUpdateStaus.removed
//       }
//     } else {
//       const [ order ] = openOrders.splice(openOrderIdx, 1);   
//       closedOrders.unshift({ ...order, ...updatedOrder });
//     }

//   } else {

//     closedOrders[closeOrderIdx] = {
//       ...closedOrders[closeOrderIdx],
//       ...updatedOrder,
//     };
//   }

//   dispatch({
//     type: actionTypes.SAVE_USER_ORDERS,
//     data: { open: openOrders, close: closedOrders },
//   });
// }

// export const cancelOrder = (data: UpdateOrderEvent) => updateOrder(data);

/**
 * Update the order trades with socket
 */
// export const handleNewTrade = (data: UserTradeEvent) => (dispatch, getState) => {
//   const state = getState() as any;
//   const selectedPair = state.user.selectedPair;
//   const orders = marketsOrdersApi.endpoints.getOrders.select({symbol: selectedPair.pair_key, status: OrderExecution.open, limit: ORDER_LIMIT})(state).data
  
//   if (!orders || !orders.open || !orders.close) {
//     return;
//   }
  
//   const openOrders = [...orders.open] as Order[];
//   const closedOrders = [...orders.close] as Order[];
//   const [_pairId, _coin, _userId, orderId, _isBuyer, _isMaker, tradeId, price, amount, total, createdAt, status, fee] = data;

//   const trade: ITradeDto = {
//     tradeId,
//     amount,
//     price,
//     createdAt,
//     total,
//     fee,
//     status,
//   };

//   const openOrderIdx = openOrders.findIndex((op: Order) => op.id === orderId);
//   const orderType = openOrderIdx !== -1 ? OrderExecutionType.open : OrderExecutionType.close;

//   const originalOrder: Order | undefined = equalsIgnoreCase(orderType, OrderExecutionType.open) 
//     ? openOrders.find((op: Order) => op.id === orderId)
//     : closedOrders.find((op: Order) => op.id === orderId);

//   if (!originalOrder) {
//     return;
//   }

//   // Create a mutable copy of the order to avoid "object is not extensible" error
//   const orderAddTo: Order = {
//     ...originalOrder,
//     trades: originalOrder.trades ? [...originalOrder.trades] : []
//   };
//   const foundTrade = orderAddTo.trades.find(item => item.tradeId === trade.tradeId);
//   if (foundTrade) {
//     foundTrade.fee = trade.fee;
//     foundTrade.status = trade.status;
//   } else {
//     const tradeIndex = orderAddTo.trades.findIndex(item => new Date(item.createdAt) <= new Date(trade.createdAt));
//     if (tradeIndex !== -1) {
//       orderAddTo.trades.splice(tradeIndex, 0, trade);
//     } else {
//       orderAddTo.trades.push(trade);
//     }
//   }

//   if (orderAddTo.updateStatus === OrderUpdateStaus.removed) {
//     const filteredOpenOrders = openOrders.filter(o => o.id !== orderId);
//     const closedOrderExists = closedOrders.findIndex(o => o.id === orderId) !== -1;
    
//     if (!closedOrderExists) {
//       closedOrders.unshift(orderAddTo);
//     } else {
//       // Update existing closed order
//       const index = closedOrders.findIndex((o) => o.id === orderId);
//       if (index !== -1) {
//         closedOrders[index] = orderAddTo;
//       }
//     }

//     dispatch({
//       type: actionTypes.SAVE_USER_ORDERS,
//       data: { open: filteredOpenOrders, close: [ ...closedOrders ] },
//     });
//   } else { 
//     // Update the order in the appropriate array
//     if (equalsIgnoreCase(orderType, OrderExecutionType.open)) {
//       const index = openOrders.findIndex((o) => o.id === orderId);
//       if (index !== -1) {
//         openOrders[index] = orderAddTo;
//       }
//     } else {
//       const index = closedOrders.findIndex((o) => o.id === orderId);
//       if (index !== -1) {
//         closedOrders[index] = orderAddTo;
//       }
//     }
    
//     dispatch({
//       type: actionTypes.SAVE_USER_ORDERS,
//       data: { ...orders, [orderType]: equalsIgnoreCase(orderType, OrderExecutionType.open) ? openOrders : closedOrders },
//     });
//   }
// };

// export const addTradesToOrder = (data: Order) => (dispatch, getState: any) => {
//   const state = getState() as any;
//   const selectedPair = state.user.selectedPair;
  
//   const cacheKey = {
//     symbol: selectedPair.pair_key,
//     status: OrderExecution.open,
//     limit: ORDER_LIMIT,
//     startTime: undefined,
//     endTime: undefined,
//   };

//   const { id, trades } = data;
//   dispatch(marketsOrdersApi.util.updateQueryData("getOrders", cacheKey, (draft)=>{
//     if (!draft || !draft.open || !draft.close) {
//       return;
//     }
//     const { open, close } = draft;


//   const openOrderIdx = open.findIndex((op: Order) => op.id === id);
//   const orderType = openOrderIdx !== -1 ? OrderExecutionType.open : OrderExecutionType.close;

//   const orderAddTo: Order = equalsIgnoreCase(orderType, OrderExecutionType.open)
//     ? open.find((op: Order) => op.id === id)
//     : close.find((op: Order) => op.id === id);

//   if (!orderAddTo) {
//     return;
//   }

//   // check if existing trade is more actual
//   orderAddTo.trades = orderAddTo.trades || [];
//   const newTrades = getActualElement(orderAddTo.trades, trades, (a: ITradeDto, b: ITradeDto) => a.tradeId === b.tradeId);
//   // filter trades duplications
//   const allTrades = [...orderAddTo.trades, ...newTrades]
//   .filter((el, idx, arr) => idx === arr.findIndex((t) => t.tradeId === el.tradeId)) as ITradeDto[];

//   orderAddTo.trades = [...allTrades.sort((a, b) => sortByDate(a.createdAt, b.createdAt))];

//   const newOrders = equalsIgnoreCase(orderType, OrderExecutionType.open)
//     ? open.map((o) => o.id === id ? orderAddTo : o)
//     : close.map((o) => o.id === id ? orderAddTo : o);

//   draft[orderType] = newOrders;

//   }));
// }